import { COLOR, textGradient } from "../../common/css/colors";

import "../../styles/button.css";

interface ButtonProps {
    text: string;
    variant?: string;
    size?: string;
    borderRadius?: string;
    fullWidth?: boolean;
    background?: string;
    color?: string;
    textGradient?: { from: string; to: string; deg?: number };
    style?: React.CSSProperties;
    onClick?: () => void;
    disabled?: boolean;
    glow?: boolean;
}

export const Button = ({
    text,
    variant,
    size,
    borderRadius,
    fullWidth,
    background,
    color,
    textGradient: _textGradient,
    style: extraStyles,
    onClick,
    disabled,
    glow,
}: ButtonProps) => {
    const style: React.CSSProperties = {
        padding: "0.5em",
        border:
            variant === "outline"
                ? `1px solid ${color ?? COLOR.teal5}`
                : "none",
        ...extraStyles,
    } as Record<string, any>;

    const textStyle = {
        color: color ? color : variant === "outline" ? COLOR.teal5 : "white",
        fontWeight: "600",
        userSelect: "none",
    } as Record<string, any>;

    let dim = 14;
    switch (size) {
        case "xs":
            dim = 12;
            break;
        case "md":
            dim = 18;
            break;
        case "lg":
            dim = 20;
            break;
    }

    let borderDim = 4;
    switch (borderRadius) {
        case "xs":
            borderDim = 2;
            break;
        case "md":
            borderDim = 8;
            break;
        case "lg":
            borderDim = 12;
            break;
    }

    style["borderRadius"] = `${borderDim}px`;
    style["background"] =
        variant === "outline" ? "transparent" : background ?? COLOR.teal5;
    style["fontSize"] = `${dim}px`;

    if (fullWidth) {
        style["width"] = "100%";
    }

    if (_textGradient) {
        Object.assign(
            textStyle,
            textGradient(
                _textGradient.from,
                _textGradient.to,
                _textGradient.deg,
            ),
        );
    }

    return (
        <button
            className={`btn ${glow && "glow"}`}
            style={style}
            type="button"
            onClick={onClick}
            disabled={disabled ?? false}
        >
            <span style={textStyle}>{text}</span>
        </button>
    );
};
